import React from 'react';
import RequiredLabel from './RequiredLabel';

interface FormItemProps extends React.PropsWithChildren {
  type: 'text' | 'select' | 'date';
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
}

export default function FormItem({
  type, name, label, placeholder, required = false, children,
}: FormItemProps) {
  if (type === 'select') {
    return (
      <div className="leave-form-item">
        <label htmlFor={name}>
          <span className="leave-form-item-label">
            <RequiredLabel required={required}>{label}</RequiredLabel>
          </span>
          <select id={name} name={name}>
            {placeholder && (<option value="" disabled>{placeholder}</option>)}
            {children}
          </select>
        </label>
      </div>
    );
  }

  return (
    <div className="leave-form-item">
      <label htmlFor={name}>
        <span className="leave-form-item-label">
          <RequiredLabel required={required}>{label}</RequiredLabel>
        </span>
        <input type={type} id={name} name={name} placeholder={placeholder || ''} />
      </label>
    </div>
  );
}
